<template>
  <section>
    <Nav :step="sectorFromState.inAppStep"
         @goToBase="goToBase"
         @goToLocation="goToLocation"
         @goToInsulation="goToInsulation"
         @goToDampCourse="goToDampCourse"
         @goToSector="goToSector"
         @addFromNav="addFromNav"
         ref="Nav"/>
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#E30713"
             :height = 145
             :width = 145
             :opacity = 1
             backgroundColor="#eeeeee"
             :z-index = 3
             :is-full-page="fullPage"
             ></loading>
    <div class="container">
      <div class="row tr"
           :class="{'row__blur': isShowModalMaterials || isShowModalBase}">
        <div class="minor__title minor__title-btn">
          Промежуточный расчет
          <DeleteBtn v-if="sectors.length > 1"
                     @showDeleteConfirmation="showDeleteConfirmation"/>
        </div>
      </div>
      <div class="row tr"
           :class="{'row__blur': isShowModalMaterials || isShowModalBase}">
        <div class="common__pane">
          <div class="minorResult__materials">
            <div class="minorResult__materials-item">
              <div class="title">
                {{base}}
              </div>
              <div class="minorResult__materials-item--single"
                   @click="isShowModalBase = !isShowModalBase">
                <div class="name">
                  <span class="name__mobile">{{base}}</span><br>
                  {{ getInsulationMaterial(sectorFromState.base.id).name }}
                  {{ getInsulationMaterial(sectorFromState.base.id).size }}
                  <span v-if="sectorFromState.base.hasOwnProperty('type')">
                  ({{ sectorFromState.base.type.size }}мм)
                </span>
                </div>
                <button class="btn">
                  <img src="@/assets/img/change.svg" alt="change">
                </button>
              </div>
            </div>
            <div class="minorResult__materials-item">
              <div class="title">
                {{dampCourse}}
              </div>
              <div class="minorResult__materials-item--single"
                   @click="isShowModalMaterials = !isShowModalMaterials">
                <div class="name">
                  <span class="name__mobile">{{dampCourse}}</span><br>
                  {{ getDampCourseMaterial(sectorFromState.material.id).name }}
                </div>
                <button class="btn">
                  <img src="@/assets/img/change.svg" alt="change">
                </button>
              </div>
            </div>
          </div>
          <div class="zones__wrapper">
            <div class="zones__titles-mob">
              <div class="zones__titles-mob--item">
                <div>
                  <v-popover
                    offset="5"
                    placement="right"
                    trigger="hover"
                    class="tooltip__btn">
                    <img src="@/assets/img/question.svg" alt="?">
                    <template slot="popover">
                      <div class="d-flex flex-column">
                        <span class="zones__titles-mob--tooltip">Зона C: угловая</span>
                        <span class="zones__titles-mob--tooltip">Зона D: парапетная</span>
                        <span class="zones__titles-mob--tooltip">Зона E: центральная</span>
                      </div>
                    </template>
                  </v-popover>
                </div>
                Ширина<br> рулона гидро<span>-</span><br>изоляции
              </div>
              <div class="zones__titles-mob--item"
                   v-if="sectorFromState.material.mounting !== 'ballast'">
                Шаг<br> крепежа,<br> мм
              </div>
              <div class="zones__titles-mob--item"
                   v-if="sectorFromState.material.mounting !== 'ballast'">
                Требуемое<br> к-во крепежа,<br> шт / м²
              </div>
              <div class="zones__titles-mob--item"
                   v-if="sectorFromState.material.mounting !== 'ballast'">
                <b>Расчетное<br> к-во крепежа,<br> шт / м²</b>
              </div>
              <div class="zones__titles-mob--item"
                  v-if="sectorFromState.material.mounting === 'ballast'">
                Толщина<br> балласта, мм
              </div>
            </div>
            <div class="zones">
              <div class="zones__item" v-for="(zone, i) in minorResult" :key="i">
                <div class="zones__item-title">
                  <span class="zones__item-title--type" v-if="zone.name === 'C'">Угловая</span>
                  <span class="zones__item-title--type" v-else-if="zone.name === 'D'">
                  Парапетная
                </span>
                  <span class="zones__item-title--type" v-else>Центральная</span>
                  зона {{ zone.name }}
                </div>
                <div class="zones__item-text">
                  Ширина рулона гидроизоляции
                </div>
                <div class="zones__item-plusMinus">
                  <button @click="updateSectorSize(zone.recommended - 1, zone.name);
                  zone.recommended -= 1"
                          :disabled="checkRecommendedOrSelected(zone.recommended,
                    zone.name) === 0"
                          class="common__plusMinus-button">
                    <img src="@/assets/img/prev.svg" alt="←">
                  </button>
                  <div class="common__plusMinus-input value"
                       :class="{'disabled': zone.options.length <= 1}">
                    {{ zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].rollWidth }} м
                  </div>
                  <button @click="updateSectorSize(zone.recommended + 1, zone.name);
                  zone.recommended += 1"
                          :disabled="checkRecommendedOrSelected(zone.recommended,
                    zone.name) + 1 === zone.options.length"
                          class="common__plusMinus-button">
                    <img src="@/assets/img/next.svg" alt="→">
                  </button>
                </div>
                <div class="zones__item-params"
                     v-if="zone.options[checkRecommendedOrSelected(zone.recommended,
                     zone.name)].hasOwnProperty('step')">
                  <div class="zones__item-text">
                    Шаг крепежа
                  </div>
                  <div class="zones__item-params--val">
                    {{ zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].step }} <span class="units">мм</span>
                  </div>
                </div>
                <div class="zones__item-params"
                     v-if="zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].hasOwnProperty('required')">
                  <div class="zones__item-text">
                    Требуемое к-во крепежа
                  </div>
                  <div class="zones__item-params--val">
                    {{ zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].required }} <span class="units">шт / м²</span>
                  </div>
                </div>
                <div class="zones__item-params estimated"
                     v-if="zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].hasOwnProperty('estimated')">
                  <div class="zones__item-text">
                    Расчетное к-во крепежа
                  </div>
                  <div class="zones__item-params--val">
                    <b>{{ zone.options[checkRecommendedOrSelected(zone.recommended,
                      zone.name)].estimated }}
                      <span class="units">шт / м²</span>
                    </b>
                  </div>
                </div>
                <div class="zones__item-params ballast"
                     v-if="zone.options[checkRecommendedOrSelected(zone.recommended,
                      zone.name)].hasOwnProperty('thickness')">
                  <div class="zones__item-text">
                    Толщина<br> балласта
                  </div>
                  <div class="zones__item-params--val">
                    {{ zone.options[checkRecommendedOrSelected(zone.recommended,
                    zone.name)].thickness }} мм
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="common__pane plan__wrapper">
          <div class="plan__wrapper-title">План кровли</div>
          <div class="plan__figure">
            <Figure :defaultSvgParams="defaultSvgParams"
                    :sideB="sectorFromState.sideB"
                    :sideL="sectorFromState.sideL"/>
          </div>
        </div>
        <disclaimer />
        <div class="buttons__nav wizard__buttons-nav">
          <button @click="goToSector"
                  class="common__button-prev">
            <img src="@/assets/img/common-arrow-prev.svg" alt="←">
            <span>Параметры участка</span>
          </button>
          <button @click="goToResult" class="common__button-next special">
            Рассчитать все участки
            <img src="@/assets/img/calc.svg" alt="calc">
          </button>
        </div>
        <div class="wizard__buttons-nav--result">
          <button class="common__button-result" @click="addSector">
            <img src="@/assets/img/big-plus.svg" alt="+">
            Добавить новый участок
          </button>
          <div class="text">
            Параметры текущего участка сохранятся и добавятся в общий расчет
          </div>
        </div>
      </div>
      <transition name="slide">
        <div class="materials__modal" v-if="isShowModalBase">
          <div class="materials__modal-body">
            <Base :isInModal="true"
                  :insulationMaterial="getInsulationMaterial(sectorFromState.base.id)"
                  @closeModal="closeModalBase"
                  @runPost="fetchMinorResult"/>
          </div>
        </div>
      </transition>
      <div class="materials__modal-mask"
           v-if="isShowModalBase"
           @click="closeModalBase">
      </div>
      <transition name="slide">
        <div class="materials__modal" v-if="isShowModalMaterials">
          <div class="materials__modal-body">
            <div class="container">
              <Materials :isInModal="true"
                         @closeModal="closeModalMaterials"
                         @runPost="fetchMinorResult"/>
            </div>
          </div>
        </div>
      </transition>
      <div class="materials__modal-mask"
           v-if="isShowModalMaterials"
           @click="isShowModalMaterials = !isShowModalMaterials">
      </div>
    </div>
  </section>
</template>
<script>

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import Figure from '@/components/Figure.vue';
import Materials from '@/components/Materials.vue';
import Base from '@/components/Base.vue';
import Nav from '@/components/Nav.vue';
import DeleteBtn from '@/components/DeleteBtn.vue';
import Disclaimer from '@/components/Disclaimer.vue';
import { dataLayerPushEvent } from '@/utils/GTM';

export default {
  data() {
    return {
      position: 0,
      isShowModalMaterials: false,
      isShowModalBase: false,
      base: 'Основание кровли',
      dampCourse: 'Гидроизоляция',
      minorResult: [],
      fullPage: true,
      isLoading: false,
    };
  },
  components: {
    Disclaimer,
    Figure,
    Materials,
    Base,
    Nav,
    DeleteBtn,
    Loading,
  },
  watch: {
    isShowModalMaterials() {
      if (this.isShowModalMaterials) {
        this.$root.offBodyScroll();
      } else {
        this.$root.onBodyScroll();
      }
    },
    isShowModalBase() {
      if (this.isShowModalBase) {
        this.$root.offBodyScroll();
      } else {
        this.$root.onBodyScroll();
      }
    },
  },
  methods: {
    ...mapMutations({
      UPDATE_SECTOR_MATERIAL_SIZE_PARAM: 'UPDATE_SECTOR_MATERIAL_SIZE_PARAM',
    }),
    showDeleteConfirmation() {
      this.$emit('showDeleteConfirmation');
    },
    goToLocation() {
      this.$emit('goToLocation');
    },
    goToBase() {
      this.$emit('goToBase');
    },
    goToInsulation() {
      this.$emit('goToInsulation');
    },
    goToSector() {
      this.$emit('goToSector');
    },
    goToDampCourse() {
      this.$emit('goToDampCourse');
    },
    addFromNav() {
      this.$emit('addFromNav');
    },
    goToResult() {
      dataLayerPushEvent('calc-roofload-step7');
      this.$router.push('/result');
    },
    getInsulationMaterial(id) {
      return this.insulationMaterials[this.insulationMaterials.findIndex(p => p.id === id)];
    },
    getDampCourseMaterial(id) {
      return this.dampCourseMaterials[this.dampCourseMaterials.findIndex(p => p.id === id)];
    },
    closeModalMaterials() {
      this.isShowModalMaterials = !this.isShowModalMaterials;
    },
    closeModalBase() {
      if (!this.isDisabled) {
        this.fetchMinorResult();
        this.isShowModalBase = !this.isShowModalBase;
      }
    },
    async fetchMinorResult() {
      this.isLoading = true;
      const baseUrl = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`;
      const postData = new URLSearchParams();
      postData.append('sector', JSON.stringify(this.sectorFromState));
      postData.append('location', JSON.stringify(this.location));
      axios.post(`${baseUrl}service_api/calculate`, postData)
        .then((response) => {
          if (process.env.NODE_ENV === 'development') {
            console.log(response.data);
          }
          this.minorResult = response.data;
          if (this.checkIfSizeEmpty('C')) {
            this.UPDATE_SECTOR_MATERIAL_SIZE_PARAM({
              id: this.sectorId,
              param: 'C',
              val: this.findMinorResultItem('C').recommended,
            });
          } else {
            this.findMinorResultItem('C').recommended = this.sectorFromState.material.size.C;
          }
          if (this.checkIfSizeEmpty('D')) {
            this.UPDATE_SECTOR_MATERIAL_SIZE_PARAM({
              id: this.sectorId,
              param: 'D',
              val: this.findMinorResultItem('D').recommended,
            });
          } else {
            this.findMinorResultItem('D').recommended = this.sectorFromState.material.size.D;
          }
          if (this.checkIfSizeEmpty('E')) {
            this.UPDATE_SECTOR_MATERIAL_SIZE_PARAM({
              id: this.sectorId,
              param: 'E',
              val: this.findMinorResultItem('E').recommended,
            });
          } else {
            this.findMinorResultItem('E').recommended = this.sectorFromState.material.size.E;
          }
          // console.log(response.data);
          this.isLoading = false;
        });
    },
    addSector() {
      this.$emit('addSector');
    },
    checkRecommendedOrSelected(index, name) {
      if (this.checkIfSizeEmpty(name)) {
        return index;
      } return this.sectorFromState.material.size[name];
    },
    checkIfSizeEmpty(name) {
      return this.sectorFromState.material.size[name] === '';
    },
    findMinorResultItem(name) {
      return this.minorResult[this.minorResult.findIndex(p => p.name === name)];
    },
    updateSectorSize(index, name) {
      this.UPDATE_SECTOR_MATERIAL_SIZE_PARAM({
        id: this.sectorId,
        param: name,
        val: index,
      });
    },
  },
  async mounted() {
    this.fetchMinorResult();
  },
  computed: {
    ...mapState({
      location: state => state.location,
      minorResultBallast: state => state.minorResultBallast,
      defaultSvgParams: state => state.defaultSvgParams,
      insulationMaterials: state => state.insulationMaterials,
      dampCourseMaterials: state => state.materials,
      sectors: state => state.sectors,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
    isDisabled() {
      return this.currentMaterial.hasTypes ? this.disableWithTypes : this.disableWithoutTypes;
    },
    disableWithTypes() {
      return !(this.sectorFromState.base.id !== null
        && this.sectorFromState.base.type.size > 0);
    },
    disableWithoutTypes() {
      return this.sectorFromState.base.id === null;
    },
    currentMaterial() {
      return this.sectorFromState.base.id === null
        ? this.insulationMaterials[0]
        : this.insulationMaterials[this.insulationMaterials.findIndex(p => p.id
          === this.sectorFromState.base.id)];
    },
    currentResultType() {
      return this.sectorFromState.material.mounting === 'ballast'
        ? this.minorResultBallast : this.minorResult;
    },
  },
};
</script>
<style lang="sass">
  .zones
    display: flex
    flex-direction: row
    align-items: center
    color: $black
    +media((display: (320: flex, 600: grid)))
    grid-template-columns: repeat(3, 1fr)
    +media((grid-column-gap: (600: 0, 992: rem(40))))
    // +media((padding-top: (320: 0, 992: rem(40))))
    +media((padding-left: (320: rem(13), 800: 0)))
    +media((justify-content: (320: flex-end, 800: space-between)))
    &__wrapper
      display: grid
      +media((padding-top: (320: 0, 576: rem(25), 800: rem(40))))
      +media((grid-template-columns: (320: 4fr 8fr, 450: 5fr 7fr, 480: 1fr 1fr, 800: 1fr)))
    &__titles
      &-mob
        position: relative
        +media((display: (320: flex, 800: none)))
        flex-direction: column
        .tooltip__btn
          position: absolute
          left: 0
          top: 0
          line-height: 0
        &--tooltip
          text-align: left
        &--item
          text-align: left
          font-style: normal
          display: flex
          flex-direction: column
          justify-content: center
          align-items: flex-start
          font-weight: 500
          line-height: rem(18)
          color: #5C5C5C
          position: relative
          height: rem(74)
          +media((font-size: (320: rem(10), 360: rem(12))))
          &:after
            height: rem(1)
            width: calc(100vw - 48px)
            background: #ECECEC
            content: ""
            position: absolute
            bottom: 0
            left: 0
            +media((display: (320: block, 600: none)))
          &:first-of-type
            +media((height: (320: rem(156), 600: rem(116))))
            justify-content: flex-end
            +media((padding-bottom: (320: rem(44), 400: rem(52), 480: rem(62), 600: rem(28),
            678: rem(38))))
          &:last-of-type
            padding-bottom: 0
            &:after
              display: none
          br
            +media((display: (320: inline-block, 400: none)))
          span
            +media((display: (320: contents, 400: none)))
    &__item
      +media((border-right: (320: none, 992: rem(1) solid #ECECEC)))
      +media((padding-right: (320: 0, 600: rem(15), 800: rem(25), 992: rem(40))))
      +media((height: (320: 100%, 800: auto)))
      &:first-of-type
        .zones__item-plusMinus
          .value
            +media((border-radius: (320: rem(4) 0 0 rem(4), 600: rem(4))))
            +media((border-right-width: (320: 0, 600: rem(1))))
      &:nth-child(2)
        .zones__item-plusMinus
          .value
            +media((border-radius: (320: 0, 600: rem(4))))
            +media((border-right-width: (320: 0, 600: rem(1))))
            +media((border-left-width: (320: 0, 600: rem(1))))
      &:last-of-type
        border-color: transparent
        .zones__item-plusMinus
          .value
            +media((border-radius: (320: 0 rem(4) rem(4) 0, 600: rem(4))))
            +media((border-left-width: (320: 0, 600: rem(1))))
      &:first-of-type, &:nth-child(2)
        .zones__item-plusMinus
          .value
            &:after
              content: ""
              background: #ECECEC
              height: rem(24)
              width: rem(1)
              position: absolute
              right: 0
              top: 50%
              transform: translateY(-50%)
              +media((display: (320: block, 800: none)))
      &-plusMinus
        display: flex
        align-items: center
        +media((padding: (320: 0 0 rem(20), 600: rem(17) 0 rem(27))))
        +media((flex-direction: (320: column, 600: row)))
        .common__plusMinus-button
          +media((transform: (320: rotate(90deg), 600: rotate(0))))
        .value
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          position: relative
          +media((width: (320: rem(60), 360: rem(65), 400: rem(68))))
          +media((font-size: (320: rem(13), 800: rem(14))))
          +media((line-height: (320: rem(19), 800: rem(21))))
          +media((margin: (320: rem(10) 0, 600: 0 rem(5), 800: 0 rem(9))))
          &:hover
            border: rem(1) solid $grey
            box-shadow: none
        .disabled
          opacity: .3
      &-title
        font-style: normal
        font-weight: bold
        +media((text-align: (320: center, 800: left)))
        +media((padding-bottom: (320: rem(16), 800: rem(40))))
        +media((font-size: (320: rem(13), 800: rem(18))))
        +media((line-height: (320: rem(16), 800: rem(22))))
        &--type
          +media((display: (320: none, 800: inline-block)))
      &-text
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(18)
        color: #5C5C5C
        text-align: left
        +media((display: (320: none, 800: block)))
      &-params
        display: flex
        flex-direction: row
        align-items: center
        +media((height: (320: rem(74), 800: auto)))
        +media((padding-bottom: (320: 0, 800: rem(34))))
        +media((justify-content: (320: center, 800: flex-start)))
        &.estimated
          +media((padding: (320: 0, 800: rem(34) 0 rem(10))))
          +media((border-top: (320: none, 800: rem(1) solid #ECECEC)))
        &.ballast
          +media((padding: (320: 0, 800: 0 0 rem(10))))
        .zones__item-text
          max-width: rem(120)
          width: rem(120)
        &--val
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(21)
          text-align: left
          .units
            +media((display: (320: none, 800: inline-block)))
  .plan
    &__wrapper
      margin-top: rem(34)
      &-title
        font-style: normal
        font-weight: bold
        color: $black
        +media((padding-bottom: (320: rem(20), 768: rem(34))))
        +media((font-size: (320: rem(15), 768: rem(18))))
        +media((line-height: (320: rem(24), 768: rem(22))))
        +media((text-align: (320: center, 768: left)))
    &__figure
      +media((padding: (320: 0, 768: 0 rem(60), 992: 0 rem(120))))
      svg
        max-width: 100%
        height: auto
  .minorResult
    &__materials
      display: grid
      +media((grid-column-gap: (320: rem(8), 768: rem(40))))
      padding-bottom: rem(34)
      +media((grid-template-columns: (320: 1fr, 576: 1fr 1fr)))
      grid-row-gap: rem(8)
      +media((border-bottom: (320: none, 576: rem(1) solid #ECECEC)))
      &-item
        .title
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(18)
          color: $black
          text-align: left
          padding-bottom: rem(25)
          +media((display: (320: none, 992: block)))
        &--single
          background: #FFFFFF
          border: rem(1) solid $grey
          box-sizing: border-box
          border-radius: rem(4)
          display: flex
          flex-direction: row
          align-items: center
          justify-content: space-between
          transition: .5s
          cursor: pointer
          +media((padding: (320: rem(16) rem(18), 992: rem(14) rem(16) rem(14) rem(20))))
          &:hover
            box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.15)
            border-color: #ECECEC
            .name
              color: $black
            .btn
              img
                transform: rotate(-180deg)
          .name
            font-style: normal
            font-weight: 500
            line-height: rem(18)
            color: #5C5C5C
            text-align: left
            +media((font-size: (320: rem(12), 360: rem(13), 992: rem(14))))
            br
              +media((display: (320: inline-block, 992: none)))
            &__mobile
              font-size: rem(13)
              line-height: rem(21)
              font-weight: bold
              color: $black
              +media((display: (320: inline-block, 992: none)))
          .btn
            box-shadow: none
            outline: none
            cursor: pointer
            border: none
            background: none
            padding: 0
            line-height: 0
            img
              transition: .5s
  .materials
    &__modal
      max-height: 72vh
      width: 100%
      position: fixed
      top: 0
      left: 0
      z-index: 5
      overflow-y: auto
      &-body
        background: #fff
        height: auto
        max-height: 100%
        transition: .5s
        padding-bottom: rem(51)
        width: 100%
        box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16)
        position: relative
        z-index: 1
      &-mask
        background: rgba(51, 51, 51, 0.3)
        position: fixed
        left: 0
        top: 0
        height: 100vh
        width: 100%
  .slide-enter-active, .slide-leave-active
    transition: .5s
  .slide-enter, .slide-leave-to
    transform: translateY(-100%)
  .tr
    transition: .5s
  .row
    &__blur
      // filter: blur(rem(10))
</style>
